import { render, staticRenderFns } from "./kpi-progress.vue?vue&type=template&id=40e63abf&scoped=true"
import script from "./kpi-progress.vue?vue&type=script&lang=js"
export * from "./kpi-progress.vue?vue&type=script&lang=js"
import style0 from "./kpi-progress.vue?vue&type=style&index=0&id=40e63abf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e63abf",
  null
  
)

export default component.exports